import { render, staticRenderFns } from "./mall_online_item.vue?vue&type=template&id=0ba61960&scoped=true"
import script from "./mall_online_item.vue?vue&type=script&lang=js"
export * from "./mall_online_item.vue?vue&type=script&lang=js"
import style0 from "../css/common.less?vue&type=style&index=0&id=0ba61960&prod&lang=less&scoped=true&external"
import style1 from "./mall_online_item.vue?vue&type=style&index=1&id=0ba61960&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba61960",
  null
  
)

export default component.exports